import { Box, Typography } from '@mui/material';
import { Button, Dialog } from '@peritasai/ui-components';
import { useTranslation } from 'react-i18next';

const footerSx = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
};

type RemoveTrayConfirmationModalProps = {
  open: boolean;
  trayName: string;
  trayLocation: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

export const RemoveTrayConfirmationModal = ({
  open,
  trayName,
  trayLocation,
  onCancel,
  onConfirm,
}: RemoveTrayConfirmationModalProps) => {
  const { t } = useTranslation(['periverse']);

  return (
    <Dialog
      open={open}
      title={t('pages.caseCartAssembly.progressScreen.removeConfirmationTitle')}
      onClose={onCancel}
      maxWidth="xs"
      footer={
        <Box sx={footerSx}>
          <Button
            variant="outlined"
            onClick={onCancel}
            data-testid="remove-tray-cancel-button"
          >
            {t('pages.caseCartAssembly.progressScreen.removeConfirmationBackLabel')}
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            data-testid="remove-tray-confirm-button"
            aria-label={t(
              'pages.caseCartAssembly.progressScreen.removeConfirmationConfirmLabel'
            )}
          >
            {t('pages.caseCartAssembly.progressScreen.removeConfirmationConfirmLabel')}
          </Button>
        </Box>
      }
    >
      <Typography data-testid="remove-tray-confirmation-body">
        {t('pages.caseCartAssembly.progressScreen.removeConfirmationBody', {
          name: trayName,
          location: trayLocation ?? '',
        })}
      </Typography>
    </Dialog>
  );
};
